module.exports = __webpack_public_path__ + "static/media/john.7817cfab.webp";